import React, { useEffect, Fragment } from 'react';
import { initCanvas, initTemplateCode } from './../CanvasActions';

const FrontCanvas = React.memo((props) => {
    /* componentDidMount */
    useEffect(() => {
        if (props.templateId !== props.templateCode || ['p1t10', 'p1t12', 'p1t17', 'p1t18', 'p2t2', 'p2t4', 'p4t1', 'p4t3',
            'p12t1', 'p12t2', 'p12t3', 'p12t4', 'p12t5', 'p12t6', 'p17t1', 'p17t2', 'p17t3', 'p17t4', 'p17t5', 'p18t1', 'p18t3', 'p18t4', 'p19t1',
            'p20t1', 'p20t2', 'p20t3', 'p20t4', 'p20t5', 'p20t6', 'p20t7', 'p20t8', 'p20t9', 'p22t1', 'p22t2', 'p22t3'].includes(props.templateCode)) {
            return;
        }
        if (props.templateCode === 'p12t7' && parseInt(props.addEnvelopes) === 0) {
            return;
        }
        if (props.templateCode === 'p12t8' && parseInt(props.addEnvelopes) === 0) {
            return;
        }
        if (props.templateCode === 'p12t9' && parseInt(props.addEnvelopes) === 0) {
            return;
        }
        if (props.templateCode === 'p12t10' && parseInt(props.addEnvelopes) === 0) {
            return;
        }
        initTemplateCode(props.templateCode);
        initCanvas();
    }, [props.templateCode, props.templateId, props.addEnvelopes]);

    let canvasStyle = {};
    let className = '';
    if (['p1t10', 'p1t17', 'p1t18', 'p2t2', 'p2t4', 'p4t1', 'p4t3', 'p12t1', 'p12t2', 'p12t3', 'p12t4', 'p12t5', 'p12t6'].includes(props.templateCode)) {
        className = ' hidden';
    }
    if (props.templateCode === 'p12t7' && parseInt(props.addEnvelopes) === 0) {
        canvasStyle.visibility = 'hidden';
    }
    if (props.templateCode === 'p12t8' && parseInt(props.addEnvelopes) === 0) {
        canvasStyle.visibility = 'hidden';
    }
    if (props.templateCode === 'p12t9' && parseInt(props.addEnvelopes) === 0) {
        canvasStyle.visibility = 'hidden';
    }
    if (props.templateCode === 'p12t10' && parseInt(props.addEnvelopes) === 0) {
        canvasStyle.visibility = 'hidden';
    }

    const renderA6Product = (name) => {
        let envelopeImage = null;
        if (parseInt(props.addEnvelopes)) {
            if (props.templateCode === 'p12t7' || props.templateCode === 'p12t8' || props.templateCode === 'p12t9' || props.templateCode === 'p12t10') {
                envelopeImage = (
                    <Fragment>
                        <h5 className="mt-4">Matching A6 Envelope:</h5>
                    </Fragment>
                );
            } else {
                envelopeImage = (
                    <Fragment>
                        <h5 className="mt-4">Matching A6 Envelope:</h5>
                        <img
                            className="preview-a6-image"
                            src={'https://ac-ut-health.s3.amazonaws.com/static-preview-images/' + name + '-a6-envelope.jpg'}
                            alt="A6 Envelope"
                        />
                    </Fragment>
                );
            }
        }

        let color = '';
        if (parseInt(props.front) === 1) {
            color = 'white';
        } else if (parseInt(props.front) === 2) {
            color = 'gray';
        } else if (parseInt(props.front) === 3) {
            color = 'orange';
        } else if (parseInt(props.front) === 4) {
            color = 'blue';
        }

        return (
            <Fragment>
                <h5>Foldover Thank You Card:</h5>
                <img
                    className="preview-a6-image"
                    src={'https://ac-ut-health.s3.amazonaws.com/static-preview-images/' + name + '-a6-note-card-' + color + '.jpg'}
                    alt="Notecard"
                />
                {envelopeImage}
            </Fragment>
        );
    }

    const renderSchedulingCard = () => {
        const schedulingCard = parseInt(props.schedulingCard);
        if (schedulingCard === 1) {     // The Woodlands
            return (
                <div>
                    <div className="scheduling-card">
                        <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-files/the-woodlands-front.jpg" alt="Scheduling Cards" />
                    </div>
                    <h5 className="mt-3">Back Side:</h5>
                    <div className="scheduling-card">
                        <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-files/the-woodlands-back.jpg" alt="Scheduling Cards" />
                    </div>
                </div>
            );
        } else if (schedulingCard === 2) {     // Texas Medical Center
            return (
                <div>
                    <div className="scheduling-card">
                        <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-files/texas-medical-center-front.jpg" alt="Scheduling Cards" />
                    </div>
                    <h5 className="mt-3">Back Side:</h5>
                    <div className="scheduling-card">
                        <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-files/texas-medical-center-back.jpg" alt="Scheduling Cards" />
                    </div>
                </div>
            );
        } else if (schedulingCard === 3) {     // Facial Plastic Surgery
            return (
                <div>
                    <div className="scheduling-card">
                        <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-files/facial-plastic-surgery-front-110524.jpg" alt="Scheduling Cards" />
                    </div>
                    <h5 className="mt-3">Back Side:</h5>
                    <div className="scheduling-card">
                        <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-files/facial-plastic-surgery-back-110524.jpg" alt="Scheduling Cards" />
                    </div>
                </div>
            );
        } else if (schedulingCard === 4) {     // Pediatric ENT
            return (
                <div>
                    <div className="scheduling-card">
                        <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-files/pediatric-ent-front.jpg" alt="Scheduling Cards" />
                    </div>
                    <h5 className="mt-3">Back Side:</h5>
                    <div className="scheduling-card">
                        <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-files/pediatric-ent-back.jpg" alt="Scheduling Cards" />
                    </div>
                </div>
            );
        } else if (schedulingCard === 5) {     // Greater Heights
            return (
                <div>
                    <div className="scheduling-card">
                        <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-files/greater-heights-front.jpg" alt="Scheduling Cards" />
                    </div>
                    <h5 className="mt-3">Back Side:</h5>
                    <div className="scheduling-card">
                        <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-files/greater-heights-back.jpg" alt="Scheduling Cards" />
                    </div>
                </div>
            );
        } else if (schedulingCard === 6) {     // Southeast Houston
            return (
                <div>
                    <div className="scheduling-card">
                        <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-files/southeast-houston-front.jpg" alt="Scheduling Cards" />
                    </div>
                    <h5 className="mt-3">Back Side:</h5>
                    <div className="scheduling-card">
                        <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-files/southeast-houston-back.jpg" alt="Scheduling Cards" />
                    </div>
                </div>
            );
        }

        return null;
    };

    let staticImageConatiner = null;
    let productContainer = null;
    let frontTitle = <h5>Front Side</h5>;
    if (props.templateCode === 'p1t10') {
        staticImageConatiner = <img className="preview-image p1t10-img" src={require('./../images/utp-billing-card.png')} alt="Billing Card" />
    } else if (props.templateCode === 'p1t17') {
        staticImageConatiner = <img className="preview-image p1t10-img" src="https://ac-ut-health.s3.amazonaws.com/variable-preview-images/billing-card-300924.png" alt="Billing Card" />
    } else if (props.templateCode === 'p1t18') {
        className = ' hidden';
        productContainer = renderSchedulingCard();
    } else if (props.templateCode === 'p2t2') {
        if (parseInt(props.color) === 1) {
            staticImageConatiner = <img className="preview-image p2t2-img" src={require('./../images/utp-letterhead-color-restricted.png')} alt="Letterhead" />
        } else if (parseInt(props.color) === 2) {
            staticImageConatiner = <img className="preview-image p2t2-img" src={require('./../images/utp-letterhead-bw-restricted.png')} alt="Letterhead" />
        }
    } else if (props.templateCode === 'p4t1') {
        if (parseInt(props.color) === 1) {
            staticImageConatiner = <img className="preview-image p4t1-img" src={require('./../images/utp-a6-foldover-notecard-white.png')} alt="Notecard" />
        } else if (parseInt(props.color) === 2) {
            staticImageConatiner = <img className="preview-image p4t1-img" src={require('./../images/utp-a6-foldover-notecard-orange.png')} alt="Notecard" />
        } else if (parseInt(props.color) === 3) {
            staticImageConatiner = <img className="preview-image p4t1-img" src={require('./../images/utp-a6-foldover-notecard-bw.png')} alt="Notecard" />
        }
    } else if (props.templateCode === 'p2t4') {
        staticImageConatiner = <img className="preview-image p2t4-img" src="https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p2t4.png" alt="Letterhead" />
    } else if (props.templateCode === 'p4t3') {
        if (parseInt(props.color) === 1) {
            staticImageConatiner = <img className="preview-image p4t1-img" src="https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p4t3-color.png" alt="Notecard" />
        } else if (parseInt(props.color) === 2) {
            staticImageConatiner = <img className="preview-image p4t1-img" src="https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p4t3-orange.png" alt="Notecard" />
        } else if (parseInt(props.color) === 3) {
            staticImageConatiner = <img className="preview-image p4t1-img" src="https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p4t3-black.png" alt="Notecard" />
        }
    } else if (props.templateCode === 'p12t1') {
        frontTitle = null;
        staticImageConatiner = renderA6Product('school-of-biomedical-informatics');
    } else if (props.templateCode === 'p12t2') {
        frontTitle = null;
        staticImageConatiner = renderA6Product('school-of-dentistry');
    } else if (props.templateCode === 'p12t3') {
        frontTitle = null;
        staticImageConatiner = renderA6Product('cizik-school-of-nursing');
    } else if (props.templateCode === 'p12t4') {
        frontTitle = null;
        staticImageConatiner = renderA6Product('school-of-public-health');
    } else if (props.templateCode === 'p12t5') {
        frontTitle = null;
        staticImageConatiner = renderA6Product('mcgovern-medical-school');
    } else if (props.templateCode === 'p12t6') {
        frontTitle = null;
        staticImageConatiner = renderA6Product('md-anderson');
    } else if (props.templateCode === 'p12t7') {
        frontTitle = null;
        staticImageConatiner = renderA6Product('uthealth-services');
    } else if (props.templateCode === 'p12t8') {
        frontTitle = null;
        staticImageConatiner = renderA6Product('p12t8');
    } else if (props.templateCode === 'p12t9') {
        frontTitle = null;
        staticImageConatiner = renderA6Product('p12t9');
    } else if (props.templateCode === 'p12t10') {
        frontTitle = null;
        staticImageConatiner = renderA6Product('behavioral-sciences');
    } else if (props.templateCode === 'p1t12') {
        className = ' hidden';
        productContainer = (
            <div>
                <div className="front-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/UTP-Check-image-icon.jpg" alt="Checks" />
                </div>
                <h5 className="mt-3">Back Side:</h5>
                <div className="back-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/UTP-Check-image-back-icon.jpg" alt="Checks" />
                </div>
            </div>
        );
    } else if (props.templateCode === 'p17t1') {
        className = ' hidden';

        productContainer = (
            <div>
                <div className="front-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/1405-uth_houston_-_utp_womens_care_pocket_folder_mock-up-1.jpg" alt="Pocket Folders" />
                </div>
                <h5 className="mt-3">Inside Spread</h5>
                <div className="inside-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/1405-uth_houston_-_utp_womens_care_pocket_folder_mock-up-2.jpg" alt="Pocket Folders" />
                </div>
                <h5 className="mt-3">Back Side</h5>
                <div className="back-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/1405-uth_houston_-_utp_womens_care_pocket_folder_mock-up-3.jpg" alt="Pocket Folders" />
                </div>
            </div>
        );
    } else if (props.templateCode === 'p17t2') {
        className = ' hidden';
        productContainer = (
            <div>
                <div className="front-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/orthopedics_Front_Pocket_Folder-08-19-2024.jpg" alt="Pocket Folders" />
                </div>
                <h5 className="mt-3">Inside Spread</h5>
                <div className="inside-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/ortho_surgery_-_pocket_folder_preview_online_store_-_inside-08-19-2024.jpg" alt="Pocket Folders" />
                </div>
                <h5 className="mt-3">Back Side</h5>
                <div className="back-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/ortho_surgery_-_pocket_folder_preview_online_store_-_back-good-08-19-2024.jpg" alt="Pocket Folders" />
                </div>
            </div>
        );
    } else if (props.templateCode === 'p17t3') {
        className = ' hidden';
        productContainer = (
            <div>
                <div className="front-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/1426-utp_pocket_folder_preview_front-12-28-2023.jpg" alt="Pocket Folders" />
                </div>
                <h5 className="mt-3">Inside Spread</h5>
                <div className="inside-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/1426-utp_pocket_folder_preview_inside-12-28-2023.jpg" alt="Pocket Folders" />
                </div>
                <h5 className="mt-3">Back Side</h5>
                <div className="back-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/1426-utp_pocket_folder_preview_back-12-28-2023.jpg" alt="Pocket Folders" />
                </div>
            </div>
        );
    } else if (props.templateCode === 'p17t4') {
        className = ' hidden';
        productContainer = (
            <div>
                <div className="front-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/cardiothoracic-pocket-front.jpg" alt="Pocket Folders" />
                </div>
                <h5 className="mt-3">Inside Spread</h5>
                <div className="inside-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/cardiothoracic-pocket-insided.jpg" alt="Pocket Folders" />
                </div>
                <h5 className="mt-3">Back Side</h5>
                <div className="back-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/cardiothoracic-pocket-back.jpg" alt="Pocket Folders" />
                </div>
            </div>
        );
    } else if (props.templateCode === 'p17t5') {
        className = ' hidden';
        productContainer = (
            <div>
                <div className="front-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/Urology-front.jpg" alt="Pocket Folders" />
                </div>
                <h5 className="mt-3">Inside Spread</h5>
                <div className="inside-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/Urology-inside-spread.jpg" alt="Pocket Folders" />
                </div>
                <h5 className="mt-3">Back Side</h5>
                <div className="back-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/Urology-back.jpg" alt="Pocket Folders" />
                </div>
            </div>
        );
    } else if (props.templateCode === 'p18t1') {
        className = ' hidden';
        productContainer = (
            <div>
                <div className="front-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/myuthealth-images/VATS+and+Lobectomy+Surgery+Notepad+-+Front.jpg" alt="Notepads" />
                </div>
                <h5 className="mt-3">Back Side</h5>
                <div className="back-pocket-folder">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/myuthealth-images/VATS+and+Lobectomy+Surgery+Notepad+-+Back.jpg" alt="Notepads" />
                </div>
            </div>
        );
    } else if (props.templateCode === 'p18t4') {
        className = ' hidden';
        productContainer = (
            <div>
                <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/variable-preview-images/1430-newborn_hearing_screening_results_card.jpg" alt="Notepads" />
            </div>
        );
    } else if (props.templateCode === 'p19t1') {
        frontTitle = null;
        className = ' hidden';
        productContainer = (
            <div>
                <h5 className="mt-3">Card 1</h5>
                <div className="front-holiday-card">
                    <img className="holiday-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/printready-holiday-card-1-211124.jpg" alt="Holiday" />
                </div>
                <h5 className="mt-3">Card 2</h5>
                <div className="front-holiday-card">
                    <img className="holiday-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/printready-holiday-card-2-211124.jpg" alt="Holiday" />
                </div>
                <h5 className="mt-3">Card 3</h5>
                <div className="front-holiday-card">
                    <img className="holiday-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/printready-holiday-card-3-211124.jpg" alt="Holiday" />
                </div>
                <h5 className="mt-3">Envelope</h5>
                <div className="envelope-holiday">
                    <img className="holiday-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/printready-holiday-envelope-211124.jpg" alt="Holiday" />
                </div>
            </div>
        );
    } else if (props.templateCode === 'p22t1') {
        frontTitle = null;
        className = ' hidden';

        let url = '';
        if (props.language === 'English') {
            url = 'https://ac-ut-health.s3.amazonaws.com/css/utpm-clinic_signage-travel_notice-english-preview.jpg';
        } else if (props.language === 'Spanish') {
            url = 'https://ac-ut-health.s3.amazonaws.com/css/utpm-clinic_signage-travel-notice-spanish-preview.jpg';
        }

        productContainer = (
            <div className="front-holiday-card">
                <img className="holiday-image" src={url} alt="Card" />
            </div>
        );
    } else if (props.templateCode === 'p22t2') {
        frontTitle = null;
        className = ' hidden';

        let url = '';
        if (props.language === 'English') {
            url = 'https://ac-ut-health.s3.amazonaws.com/css/cdc_cough_english-preview.jpg';
        } else if (props.language === 'Spanish') {
            url = 'https://ac-ut-health.s3.amazonaws.com/css/cdc_cough_spanish-preview.jpg';
        }

        productContainer = (
            <div className="front-holiday-card">
                <img className="holiday-image" src={url} alt="Card" />
            </div>
        );
    } else if (props.templateCode === 'p22t3') {
        frontTitle = null;
        className = ' hidden';

        productContainer = (
            <div className="front-holiday-card">
                <img className="holiday-image" src="https://ac-ut-health.s3.us-east-1.amazonaws.com/css/utpm24-clinic_signage-no_recording-eng-span_combo.jpg" alt="Card" />
            </div>
        );
    }

    if (['p11t1', 'p11t2', 'p11t3', 'p11t4', 'p11t5', 'p11t6', 'p11t7'].includes(props.templateCode)) {
        let imageUrl = '';
        if (props.templateCode === 'p11t1') {
            imageUrl = 'https://ac-ut-health.s3.amazonaws.com/static-images/cizik-school-of-nursing-n10-envelope-sample.jpg';
        } else if (props.templateCode === 'p11t2') {
            imageUrl = 'https://ac-ut-health.s3.amazonaws.com/static-images/mcgovern-medical-school-n10-envelope-sample.jpg';
        } else if (props.templateCode === 'p11t3') {
            imageUrl = 'https://ac-ut-health.s3.amazonaws.com/static-images/md-anderson-cancer-center-n10-envelope-sample.jpg';
        } else if (props.templateCode === 'p11t4') {
            imageUrl = 'https://ac-ut-health.s3.amazonaws.com/static-images/school-of-dentistry-n10-envelope-sample.jpg';
        } else if (props.templateCode === 'p11t5') {
            imageUrl = 'https://ac-ut-health.s3.amazonaws.com/static-images/school-of-public-health-n10-envelope-sample.jpg';
        } else if (props.templateCode === 'p11t6') {
            imageUrl = 'https://ac-ut-health.s3.amazonaws.com/static-images/school-of-biomedical-informatics-n10-envelope-sample.jpg';
        } else if (props.templateCode === 'p11t7') {
            imageUrl = 'https://ac-ut-health.s3.amazonaws.com/static-images/uthealth-services-n10-envelope-sample.jpg';
        } else if (props.templateCode === 'p11t22') {
            imageUrl = 'https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p11t22.png';
        } else if (props.templateCode === 'p11t23') {
            imageUrl = 'https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p11t23.png';
        } else if (props.templateCode === 'p11t24') {
            imageUrl = 'https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p11t24.png';
        } else if (props.templateCode === 'p11t25') {
            imageUrl = 'https://ac-ut-health.s3.amazonaws.com/variable-preview-images/p11t25.png';
        }

        productContainer = (
            <div className="envelope-sample">
                <h5>Example</h5>
                <img src={imageUrl} alt="Sample" />
            </div>
        );
    }

    return (
        <div className="front-canvas-container">
            {frontTitle}
            {staticImageConatiner}
            <div id={'front-canvas' + className} style={canvasStyle}></div>
            {productContainer}
        </div>
    );
});

export default FrontCanvas;
